import React, { useState } from 'react';
import PropTypes from 'prop-types';

const DuoPartImage = ({ part }) => {
    const [rotate, setRotate] = useState(false);

    const handleImageLoad = ({ target }) => {
        const { naturalWidth, naturalHeight } = target;

        if (naturalWidth > naturalHeight) {
            setRotate(true);
        }
    };

    const transformSx = { transformOrigin: 'top left', transform: 'rotate(90deg) translateX(0%) translateY(-100%)', width: '6.9in', height: '5in' };

    return (
        <img src={part?.file_url} onLoad={handleImageLoad} style={{
            // default
            width: '5in', height: '6.9in', objectFit: 'contain',
            // override width and height if the image is rotated
            ...rotate && transformSx
        }} />
    );
};

DuoPartImage.propTypes = {
    part: PropTypes.object
};

export default DuoPartImage;